import Repository from "./Repository";

const levels = "/levels";

export default {
  getLevels: (params) => Repository.get(`${levels}/`, { params: params }),
};
